import { PanelToolBase } from '@addins/core/panel';
import { Injectable } from '@angular/core';
import { StatusChangeViewPosition } from '@services/settings';

@Injectable({
  providedIn: 'root'
})
export class StatusViewService {
  statusPanelTool: PanelToolBase;
  statusViewPosition: StatusChangeViewPosition;

  constructor() {}
}
